import type { Node } from 'react'
import React, { ReactElement } from 'react'
import type { HeaderBackground } from 'app/common/header'
import { LayoutDisplay } from './LayoutDisplayContainer'

type Props = {
    headerShouldStick?: boolean,
    border?: boolean,
    color?: string,
    background?: HeaderBackground,
    children?: Node,
    withQuickSearch?: boolean,
    backgroundColor?: string
}

/*
Flow did not agree with making this component a connected component,
so we had to call the connected component from this one.
 */
const Layout = (props: Props) => <LayoutDisplay {...props} />

export { Layout }
